// @flow
import { get } from 'lodash/fp';

import convertCurrency from '../utils/convertCurrency';

function decodeBonusPack(data = {}, meta = {}) {
  return {
    bonuses: data.bonuses.map(item => ({
      challenge: get('challenge', item),
      created: item.created_at,
      expiry: item.expired_at,
      icon: get('type.icon', item),
      label: get('type.name', item),
      type: get('type.id', item),
      unclaimed: false,
      value: convertCurrency(item.balance, meta)
    })),
    totalBalance: convertCurrency(data.total_balance, meta)
  };
}

function decodeCurrentUser(data = {}, meta = {}): User {
  const campaigns = get('campaigns', data) || [];
  const campaignClaim = campaigns.find(({ key }) => key === 'claim_playup_account');
  const campaignDeposit = campaigns.find(({ key }) => key === 'claim_playup_doubleup');

  let campaignAction = get('display', campaignClaim) ? 'claim' : undefined;
  campaignAction = get('display', campaignDeposit) ? 'deposit' : campaignAction;

  const hasPlayUpCampaign = !!get('display', campaignClaim) || !!get('display', campaignDeposit);

  let campaignButtonTitle = campaignClaim || campaignDeposit ? 'BET WITH PLAYUP' : undefined;

  if (get('display', campaignClaim)) {
    campaignButtonTitle = 'GET $20 FREE';
  } else if (get('display', campaignDeposit)) {
    campaignButtonTitle = 'DEPOSIT $100 GET $200';
  }

  return {
    ...data,
    availableBalance: convertCurrency(data.available_balance, meta),
    balance: convertCurrency(data.balance, meta),
    bonusPack: decodeBonusPack(data.bonus_pack, meta),
    hasPlayUpCampaign,
    campaignAction,
    campaignButtonTitle,
    showBetWithPlayUp: Array.isArray(get('campaigns', data)) && campaigns.length === 0,
    showCampaignSmallButton: hasPlayUpCampaign && campaignAction !== 'deposit'
  };
}

export default decodeCurrentUser;
